const initialState = {
  isFetching: false,
  isFetched: false,
  isError: false,
  data: {}
}

export const ACTION_TYPES = {
  MARITAL_STATUS_LIST_REQUEST: 'MARITAL_STATUS_LIST_REQUEST',
  MARITAL_STATUS_LIST_REQUEST_SUCCESS: 'MARITAL_STATUS_LIST_REQUEST_SUCCESS',
  MARITAL_STATUS_LIST_REQUEST_ERROR: 'MARITAL_STATUS_LIST_REQUEST_ERROR'
}


export const getMaritalStatusOptions = () => ({
  type: ACTION_TYPES.MARITAL_STATUS_LIST_REQUEST
})
export const getMaritalStatusOptionsSuccess = payload => ({
  type: ACTION_TYPES.MARITAL_STATUS_LIST_REQUEST_SUCCESS,
  payload
})
export const getMaritalStatusOptionsError = () => ({
  type: ACTION_TYPES.MARITAL_STATUS_LIST_REQUEST_ERROR
})

const maritalStatusOptions = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTION_TYPES.MARITAL_STATUS_LIST_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case ACTION_TYPES.MARITAL_STATUS_LIST_REQUEST_SUCCESS:
      return {
        ...state,
        data: [...payload.data],
        isFetching: false,
        isFetched: true
      }
    case ACTION_TYPES.MARITAL_STATUS_LIST_REQUEST_ERROR:
      return {
        ...state,
        isFetching: false,
        isFetched: true
      }
    default: return state
  }
}


export default maritalStatusOptions
